import React, { useEffect, useState } from 'react'
import AppLayout from '../../layout/components/AppLayout'
import cmsServices from '../cmsServices';
import { Phone } from '@mui/icons-material';

function EmergencyPage() {
  
  const [contactList,setContectList] = useState(null);

  const getContectList = () =>{
    cmsServices.getEmergencyContactList().then(res=>{
      setContectList(res.data);
    }).catch(error=>{

    })
  }

  useEffect(()=>{
    getContectList();
  },[])


  return (
    <AppLayout>
      <div className='container'>
        <div className='row'>
          <div className='col-md-12'>
            <h3 className='text-center'>Emergency Contact List</h3>
          </div>
          <div className='col-md-12'>
            {contactList && contactList.length > 0 &&
              <ol className="list-group list-group-numbered">
                {contactList.map(contact=>
                  <li className="list-group-item d-flex justify-content-between align-items-start">
                    <div className="ms-2 me-auto">
                      <div className="fw-bold">{contact.title}</div>
                      {contact.contactTypeLabel}
                    </div>
                    <span > <a href={'tel:'+contact.phone} className='btn btn-success'> <Phone/> </a></span>
                  </li>
                )}
              </ol>
            }
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default EmergencyPage